import { Box } from "@mui/material";
import Login from "./Login";
import Signup from "./Signup";
import { sectionBox } from "../styles/ComponentStyles";
import AnimatedIcons from "../components/Layout/AnimatedIcons";

export default function Account({ onLoginSuccess }) {
  return (
    <Box
      sx={{
        ...sectionBox,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 70px)",
        width: "100vw",
        px: 2,
      }}
    >
      <AnimatedIcons mono={false}/>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "stretch",
          zIndex: 2,
        }}
      >
        <Login onLoginSuccess={onLoginSuccess} />
        <Signup />
      </Box>
    </Box>
  );
}